
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609846001170",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1719",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M880.384 283.52H676.16a32 32 0 0 1-20.608-7.552L444.352 97.344A32 32 0 0 0 423.744 89.792H145.536a32 32 0 0 0-32 32v782.848a32 32 0 0 0 32 32h734.912a32 32 0 0 0 32-32v-588.8a32 32 0 0 0-32.064-32.32zM209.408 185.664h190.912l115.776 97.856H209.472zM816.512 840.704H208.512V379.392H816.512z",
        "p-id": "1720",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M373.12 568.064m47.936 0l181.696 0q47.936 0 47.936 47.936l0 0q0 47.936-47.936 47.936l-181.696 0q-47.936 0-47.936-47.936l0 0q0-47.936 47.936-47.936Z",
        "p-id": "1721",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  